import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import Api from '../../Api';
import Button from '../../components/Button';

export default class CollectionStrip extends React.Component {
  static propTypes = {
    brandToken: PropTypes.string.isRequired,
    retailerToken: PropTypes.string.isRequired,
    className: PropTypes.string
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.findCollection = this.findCollection.bind(this);

    let collectionList = Api.cache.getProductCollections();

    this.state = {
      brandToken: props.brandToken,
      collectionList: collectionList,
      collection: null
    };
  }

  componentWillMount() {
    Api.startListen(this, 'collectionList', Api.cache.eventTypes.PRODUCT_COLLECTIONS_CHANGED);
    this.findCollection();
    Api.getProductCollections(true);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.PRODUCT_COLLECTIONS_CHANGED);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.brandToken !== this.state.brandToken) {
      this.setState({
        brandToken: nextProps.brandToken,
        collection: null
      });
      this.findCollection();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.collectionList !== this.state.collectionList) {
      this.findCollection();
    }
  }

  findCollection() {
    if (!this.state.collectionList || !this.state.collectionList.product_collections || this.state.collectionList.product_collections.length <= 0) {
      this.setState({
        collection: null
      });
      return;
    }

    let collectionDisplay = null;

    this.state.collectionList.product_collections.forEach(collection => {
      let validCollection = collection.items && collection.items.length > 0;
      collection.items.forEach(collectionItem => {
        if (collectionItem.brand_token !== this.props.brandToken) validCollection = false;
      });

      if (validCollection) collectionDisplay = collection;
    });

    this.setState({ collection: collectionDisplay });
  }

  onClick() {
    let url = `/retailer/${this.props.retailerToken}/collection/${this.state.collection.token}`;

    this.context.router.push(url);
  }

  render() {
    if (!this.state.collection) return null;

    let currentBrand = this.state.collectionList.brands[this.props.brandToken];
    let classNames = [ 'collection-strip-component' ];
    if (this.props.className) classNames.push(this.props.className);

    return (
      <div className={classNames.join(' ')}>
        <FontAwesome name="heart" />
        <span>
          <span className="shop">Shop the {this.state.collection.name}</span>
          <span className="dash">-</span>
          <span className="featuring">Featuring the {this.state.collection.items.length} <strong>Most Popular</strong> Items from {currentBrand.name}</span>
        </span>
        <Button onClick={this.onClick}>View Collection</Button>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/Brand/collection_strip.js
 **/